import React, { useEffect, useState } from 'react';
export function Countdown() {
  const [timeLeft, setTimeLeft] = useState({
    days: 3,
    hours: 14,
    minutes: 25,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          ...prev,
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        if (prev.days > 0) return {
          ...prev,
          days: prev.days - 1,
          hours: 23,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex items-center justify-center gap-2 sm:gap-3 font-black" data-id="element-272">
      <div className="flex flex-col items-center" data-id="element-273">
        <div className="bg-black text-white rounded-lg px-3 py-2 sm:px-4 sm:py-3 text-2xl sm:text-4xl" data-id="element-274">
          {format(timeLeft.days)}
        </div>
        <span className="text-xs mt-1 uppercase tracking-wider text-slate-500 font-bold" data-id="element-275">
          Días
        </span>
      </div>
      <span className="text-2xl sm:text-4xl pb-6 text-black" data-id="element-276">:</span>
      <div className="flex flex-col items-center" data-id="element-277">
        <div className="bg-black text-white rounded-lg px-3 py-2 sm:px-4 sm:py-3 text-2xl sm:text-4xl" data-id="element-278">
          {format(timeLeft.hours)}
        </div>
        <span className="text-xs mt-1 uppercase tracking-wider text-slate-500 font-bold" data-id="element-279">
          Hrs
        </span>
      </div>
      <span className="text-2xl sm:text-4xl pb-6 text-black" data-id="element-280">:</span>
      <div className="flex flex-col items-center" data-id="element-281">
        <div className="bg-black text-white rounded-lg px-3 py-2 sm:px-4 sm:py-3 text-2xl sm:text-4xl" data-id="element-282">
          {format(timeLeft.minutes)}
        </div>
        <span className="text-xs mt-1 uppercase tracking-wider text-slate-500 font-bold" data-id="element-283">
          Min
        </span>
      </div>
      <span className="text-2xl sm:text-4xl pb-6 text-black" data-id="element-284">:</span>
      <div className="flex flex-col items-center" data-id="element-285">
        <div className="bg-black text-white rounded-lg px-3 py-2 sm:px-4 sm:py-3 text-2xl sm:text-4xl" data-id="element-286">
          {format(timeLeft.seconds)}
        </div>
        <span className="text-xs mt-1 uppercase tracking-wider text-slate-500 font-bold" data-id="element-287">
          Seg
        </span>
      </div>
    </div>;
}